import React from "react";
import theme from "assets/theme";
import { HashLink } from "react-router-hash-link";

// Components
import { Stack } from "@mui/material";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
// Styled components
import { StyledButtonContainer } from "index.styles";
import { StyledEmptyCartSectionContainer } from "./index.styles";
// Utils
import useMediaQueries from "utils/mediaQueries.utils";
import { scrollToTop } from "utils/helpers/scrollToTop";

const EmptyCart = ({ toggleDrawer }) => {
  const { isLg } = useMediaQueries();
  const handleNavigateToShop = () => {
    toggleDrawer(false)();
    scrollToTop();
  };
  return (
    <StyledEmptyCartSectionContainer>
      <MKBox
        component="img"
        alt="https://www.freepik.com/free-vector/supermarket-shopping-cart-concept-illustration_82642488.htm#query=empty%20cart&position=0&from_view=keyword&track=ais_user&uuid=563f070e-a593-40bb-8578-30160fb72c4c - image by storyset"
        src="https://d3a0rs3velfrz.cloudfront.net/cart/9960436.jpg"
        sx={{ maxWidth: "300px" }}
      ></MKBox>
      <Stack justifyContent={"center"} textAlign={!isLg && "center"}>
        <MKTypography component="h4" variant="h4" gutterBottom>
          Your Cart Is
          <span style={{ color: theme.palette.accent.main }}> Currently Empty!</span>
        </MKTypography>
        <MKTypography component="p" variant={"body2"}>
          Looks like you have not added anything to your cart. Check out our packages below to get started!
        </MKTypography>
        <StyledButtonContainer>
          <MKButton
            component={HashLink}
            scroll={(el) => {
              const yOffset = -100;
              const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
              window.scrollTo({ top: y, behavior: "smooth" });
            }}
            to="/ketamine-therapy/packages#product-details-section"
            onClick={handleNavigateToShop}
            color="secondary"
            variant="outlined"
          >
            View Our Packages
          </MKButton>
        </StyledButtonContainer>
      </Stack>
    </StyledEmptyCartSectionContainer>
  );
};

/* <a href="https://www.freepik.com/free-vector/supermarket-shopping-cart-concept-illustration_82642488.htm#query=empty%20cart&position=0&from_view=keyword&track=ais_user&uuid=563f070e-a593-40bb-8578-30160fb72c4c">Image by storyset</a> on Freepik */

export default EmptyCart;
